import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ADMIN_ROLES, ANALYST_ROLES, CUSTODIAN_ROLES } from '../constants/iam-roles.constants';
import { AuthService } from '../services/auth.service';

/**
 * reserveRequirementSummaryGuard - admits Custodian, Admin and Analyst users to the
 * Reserve Requirement Summary screen. Run AFTER authGuard.
 */
export const reserveRequirementSummaryGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasRole(...CUSTODIAN_ROLES, ...ADMIN_ROLES, ...ANALYST_ROLES)) {
    return true;
  }

  await router.navigate(['/access-denied']);
  return false;
};
